import { initDexie } from '@/idb/dexie'

const dexieInstance = { db: null }

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async getDb() {
      return dexieInstance.db;
    },
    async deleteAllData(){
      if(!dexieInstance.db) return;
      await dexieInstance.db.delete();
    },
    async initializeDb(){ 
      if(dexieInstance.db){
        if(dexieInstance.db.isOpen()){
          return;
        }
      }
      dexieInstance.db = await initDexie();
    },
  }
}
